import { render } from "./Dashboard.vue?vue&type=template&id=f4122ce0&lang=pug"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"
script.render = render

export default script